import React, { useState, createContext } from 'react';
import { useFetch } from 'src/lib/FetchContext';
import { TAddress } from 'src/pages/AccountPage/components/AddressBlock/AddressBlock.i';

export interface TAccount {
  BusinessName: string;
  ClientID: number;
  FirstName: string;
  GenreID: number;
  LastName: string;
  MI: string;
  Nickname: string;
  Role: string;
  Sirname: string;
}
interface IAccountPagesContext {
  getAccount(): Promise<TAccount>;
  account: TAccount;
  getEmails(): void;
  emails: {
    Active: number,
    Email: string,
    EmailID: number,
    EmailReplaceID: number,
    EmailType: string,
    EmailTypeID: number,
  }[];
  getAddresses(): Promise<TAddress[]>;
  addresses: TAddress[];
  getStates(): void;
  states: {
    Abbreviation: string,
    StateName: string,
  }[];
  getCountries(): void;
  countries: {
    CountryName: string,
    CountryID: number,
  }[];
  getCreditCards(): any;
  creditCards: {
    CC: string,
    CardType: string,
    Exp: string,
    ID: string,
    NickName: string,
  }[];
}

export const AccountPagesContext = createContext<Partial<IAccountPagesContext>>({});

export const AccountPagesContextProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { fetch } = useFetch();
  const [account, setAccount] = useState({
    BusinessName: '',
    ClientID: null,
    FirstName: '',
    GenreID: null,
    LastName: '',
    MI: '',
    Nickname: '',
    Role: '',
    Sirname: '',
  });
  const [emails, setEmails] = useState([]);
  const [addresses, setAddresses] = useState([]);
  const [states, setStates] = useState([]);
  const [countries, setCountries] = useState([]);
  const [creditCards, setCreditCards] = useState([]);

  async function getAccount(): Promise<TAccount> {
    // NOTE: don't use this inside usePrefetchSuspense
    const accountReq = await fetch('/api/account/info/accountInfo', { credentials: 'include' });
    const accountRes = await accountReq.json();
    setAccount(accountRes[0]);
    return accountRes[0];
  }

  async function getEmails() {
    // NOTE: don't use this inside usePrefetchSuspense
    const emailReq = await fetch('/api/account/email/getAll', { credentials: 'include' });
    const emailRes = await emailReq.json();
    setEmails(emailRes);
  }

  async function getAddresses() {
    // NOTE: don't use this inside usePrefetchSuspense
    const addressReq = await fetch('/api/account/address/getAddresses', { credentials: 'include' });
    const addressRes = await addressReq.json();
    setAddresses(addressRes);
    return addressRes as TAddress[];
  }

  async function getStates() {
    // NOTE: don't use this inside usePrefetchSuspense
    const statesReq = await fetch('/api/account/address/stateList', { credentials: 'include' });
    const statesRes = await statesReq.json();
    setStates(statesRes);
  }

  async function getCountries() {
    // NOTE: don't use this inside usePrefetchSuspense
    const addressReq = await fetch('/api/account/address/countryList', { credentials: 'include' });
    const addressRes = await addressReq.json();
    setCountries(addressRes);
  }

  async function getCreditCards() {
    // NOTE: don't use this inside usePrefetchSuspense
    const cardReq = await fetch('/api/account/creditcard/getCards', { credentials: 'include' });
    const cardRes = await cardReq.json();
    setCreditCards(cardRes);
    return cardRes;
  }

  return (
    <AccountPagesContext.Provider value={{
      getAccount,
      account,
      getEmails,
      emails,
      getAddresses,
      addresses,
      getStates,
      states,
      getCountries,
      countries,
      getCreditCards,
      creditCards,
    }}>
      {children}
    </AccountPagesContext.Provider>
  );
};
